import React, { forwardRef } from 'react';
import MUIAccordionSummary, {
  AccordionSummaryProps as MUIAccordionSummaryProps,
} from '@material-ui/core/AccordionSummary';

interface AccordionSummaryProps extends MUIAccordionSummaryProps {}

const AccordionSummary = forwardRef<HTMLDivElement, AccordionSummaryProps>(
  (props, ref) => {
    return <MUIAccordionSummary {...props} ref={ref} />;
  }
);

export default AccordionSummary;
